export default __webpack_public_path__ + "static/media/marketing.f3594913.png";